import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseReviewHeader.module.scss'

import IconPrev20x20 from '@Ui/images/myhouse/IconPrev20x20.svg'
import IconWrite from '@Ui/images/myhouse/IconWrite.svg'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  prev?: { href?: string; text?: string; onClick?: () => void }
  title?: any
}

const MyhouseReviewHeader: React.FC<Props> = ({ prev, title }: Props) => {
  return (
    <header className={cx('header')}>
      <div className={cx('inner')}>
        {prev && (
          <a href={prev.href} className={cx('link_back')} onClick={handleNclickMix(NCLICK.MY_HOUSE.REVIEW_LIST.BACK, prev.onClick)}>
            <IconPrev20x20 />
            <span className="blind">{prev.text}</span>
          </a>
        )}
        <h1 className={cx('title')}>{title}</h1>
      </div>
    </header>
  )
}

export default MyhouseReviewHeader
